import { apiRequest, ApiResponse } from '../request'

/** Contato criado pelo simulador de conversas (canal Dex). Ver docs/dex-talk-channel.md. */
export interface SimulatedContact {
    chatId: number
    name: string
    status: 'OPEN' | 'CLOSED' | string
    phoneNumber: string | null
    clientId: number | null
    leadId: number | null
    department: { id: number; name: string } | null
    lastMessageAt: string | null
    createdAt: string
}

/** Mensagem como o contato a vê: `user` é ele; `assistant` (IA), `company` (equipe), `system`. */
export interface SimulatedMessage {
    id: number
    content: string
    role: 'user' | 'assistant' | 'company' | 'system' | string
    name: string | null
    createdAt: string
}

export interface CreateSimulatedContactsData {
    name: string
    quantity?: number
    phoneNumber?: string
    departmentId: number
    walletId?: number
    pipelineId?: number
    stageId?: number
}

const BASE = 'atendimento/conversation-simulator'

export async function getSimulatedContacts(): Promise<ApiResponse<SimulatedContact[]>> {
    return apiRequest<SimulatedContact[]>(`${BASE}/contacts`, {})
}

export async function createSimulatedContacts(
    data: CreateSimulatedContactsData
): Promise<ApiResponse<{ created: { chatId: number; name: string }[] }>> {
    return apiRequest<{ created: { chatId: number; name: string }[] }>(`${BASE}/contacts`, { data }, 'post')
}

export async function getSimulatedMessages(chatId: number): Promise<ApiResponse<SimulatedMessage[]>> {
    return apiRequest<SimulatedMessage[]>(`${BASE}/contacts/${chatId}/messages`, {})
}

export async function sendSimulatedMessage(
    chatId: number,
    data: { text?: string; mediaUrls?: string[] }
): Promise<ApiResponse<{ messageId: string }>> {
    return apiRequest<{ messageId: string }>(`${BASE}/contacts/${chatId}/messages`, { data }, 'post')
}

export async function deleteSimulatedContact(
    chatId: number
): Promise<ApiResponse<{ removed: boolean; failures: string[] }>> {
    return apiRequest<{ removed: boolean; failures: string[] }>(`${BASE}/contacts/${chatId}`, {}, 'delete')
}
